import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TestComponent } from './test.component';
import { AppCommonsModule } from '../../commons/app-commons.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { KYMW0F00Module } from 'src/app/commons/kymw0f/kymw0f00/kymw0f00.module';
import { KYMW5002Module } from 'src/app/commons/kymw50/kymw5002/kymw5002.module';
import { KYMW0002Module } from 'src/app/commons/kymw00/kymw0002/kymw0002.module';
import { KYMW0003Module } from 'src/app/commons/kymw00/kymw0003/kymw0003.module';
import { KYMW1202Module } from 'src/app/kymw/kymw12/kymw1202/kymw1202.module';
import { KYMW7401Module } from '../kymw74/kymw7401/kymw7401.module';
import { KYMW9006Module } from '../kymw90/kymw9006/kymw9006.module';
import { KYMW9008Module } from '../kymw90/kymw9008/kymw9008.module';
import { KYMW9007Module } from '../kymw90/kymw9007/kymw9007.module';
import { KYMW0001Module } from '../../commons/kymw00/kymw0001/kymw0001.module';

@NgModule({
  declarations: [TestComponent],
  imports: [
    CommonModule,
    AppCommonsModule,
    RouterModule,
    WjNavModule,
    WjInputModule,
    WjGridModule,
    KYMW0F00Module,
    KYMW5002Module,
    KYMW0002Module,
    KYMW0003Module,
    KYMW1202Module,
    KYMW7401Module,
    KYMW9006Module,
    KYMW9008Module,
    KYMW9007Module,
    KYMW0001Module,
  ],
})
export class TestModule {}
